// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function landmark_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var landmark = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict._0, "landmark"), null));
  if (landmark.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              landmark: landmark._0
            }
          };
  }
  var e = landmark._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".landmark" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function location_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var lat = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "lat"), null));
  if (lat.TAG === /* Ok */0) {
    var $$long = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "long"), null));
    if ($$long.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                lat: lat._0,
                long: $$long._0
              }
            };
    }
    var e = $$long._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".long" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = lat._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".lat" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function contact_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var number = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "number"), null));
    if (number.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                name: name._0,
                number: number._0
              }
            };
    }
    var e = number._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".number" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function place_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var full_address = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict._0, "full_address"), null));
  if (full_address.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              full_address: full_address._0
            }
          };
  }
  var e = full_address._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".full_address" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function bookingInfoPlace_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var full_address = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "full_address"), null));
  if (full_address.TAG === /* Ok */0) {
    var doorstep_address = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "doorstep_address"), null));
    if (doorstep_address.TAG === /* Ok */0) {
      var locality_address = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "locality_address"), null));
      if (locality_address.TAG === /* Ok */0) {
        var $$location = location_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "location"), null));
        if ($$location.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    full_address: full_address._0,
                    doorstep_address: doorstep_address._0,
                    locality_address: locality_address._0,
                    location: $$location._0
                  }
                };
        }
        var e = $$location._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".location" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = locality_address._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".locality_address" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = doorstep_address._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".doorstep_address" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = full_address._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".full_address" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function location_details_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var place = bookingInfoPlace_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "place"), null));
  if (place.TAG === /* Ok */0) {
    var contact = contact_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "contact"), null));
    if (contact.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                place: place._0,
                contact: contact._0
              }
            };
    }
    var e = contact._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".contact" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = place._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".place" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function customer_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var customer_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "customer_id"), null));
  if (customer_id.TAG === /* Ok */0) {
    var contact = contact_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "contact"), null));
    if (contact.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                customer_id: customer_id._0,
                contact: contact._0
              }
            };
    }
    var e = contact._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".contact" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = customer_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".customer_id" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function vehicle_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var vehicle_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_type"), null));
  if (vehicle_type.TAG === /* Ok */0) {
    var vehicle_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_id"), null));
    if (vehicle_id.TAG === /* Ok */0) {
      var size = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "size"), null));
      if (size.TAG === /* Ok */0) {
        var capacity = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "capacity"), null));
        if (capacity.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    vehicle_type: vehicle_type._0,
                    vehicle_id: vehicle_id._0,
                    size: size._0,
                    capacity: capacity._0
                  }
                };
        }
        var e = capacity._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".capacity" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = size._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".size" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = vehicle_id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".vehicle_id" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = vehicle_type._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".vehicle_type" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function instructions_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var description = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict._0, "description"), null));
  if (description.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              description: description._0
            }
          };
  }
  var e = description._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".description" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function delivery_instructions_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var instructions_list = Decco.listFromJson(instructions_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "instructions_list"), null));
  if (instructions_list.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              instructions_list: instructions_list._0
            }
          };
  }
  var e = instructions_list._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".instructions_list" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function delivery_note_detail_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
  if (status.TAG === /* Ok */0) {
    var dn_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dn_type"), null));
    if (dn_type.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                status: status._0,
                dn_type: dn_type._0
              }
            };
    }
    var e = dn_type._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".dn_type" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = status._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".status" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function delivery_note_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var is_requested = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_requested"), null));
  if (is_requested.TAG === /* Ok */0) {
    var details = Decco.listFromJson(delivery_note_detail_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "details"), null));
    if (details.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                is_requested: is_requested._0,
                details: details._0
              }
            };
    }
    var e = details._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".details" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = is_requested._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".is_requested" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function order_editability_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var is_editable = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict._0, "is_editable"), null));
  if (is_editable.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              is_editable: is_editable._0
            }
          };
  }
  var e = is_editable._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".is_editable" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function booking_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var customer = customer_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "customer"), null));
  if (customer.TAG === /* Ok */0) {
    var pickup_location = location_details_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pickup_location"), null));
    if (pickup_location.TAG === /* Ok */0) {
      var drop_location = Decco.optionFromJson(location_details_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "drop_location"), null));
      if (drop_location.TAG === /* Ok */0) {
        var vehicle = vehicle_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle"), null));
        if (vehicle.TAG === /* Ok */0) {
          var has_waypoints = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "has_waypoints"), null));
          if (has_waypoints.TAG === /* Ok */0) {
            var additional_waypoints_allowed = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "additional_waypoints_allowed"), null));
            if (additional_waypoints_allowed.TAG === /* Ok */0) {
              var additional_waypoints_eligible = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "additional_waypoints_eligible"), null));
              if (additional_waypoints_eligible.TAG === /* Ok */0) {
                var waypoints = Decco.listFromJson(location_details_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "waypoints"), null));
                if (waypoints.TAG === /* Ok */0) {
                  var geo_region_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "geo_region_id"), null));
                  if (geo_region_id.TAG === /* Ok */0) {
                    var geo_region_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "geo_region_name"), null));
                    if (geo_region_name.TAG === /* Ok */0) {
                      var distance = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "distance"), null));
                      if (distance.TAG === /* Ok */0) {
                        var order_source = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_source"), null));
                        if (order_source.TAG === /* Ok */0) {
                          var payment_mode = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "payment_mode"), null));
                          if (payment_mode.TAG === /* Ok */0) {
                            var goods_type = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "goods_type"), null));
                            if (goods_type.TAG === /* Ok */0) {
                              var goods_type_id = Decco.optionFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "goods_type_id"), null));
                              if (goods_type_id.TAG === /* Ok */0) {
                                var from_state = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "from_state"), null));
                                if (from_state.TAG === /* Ok */0) {
                                  var to_state = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "to_state"), null));
                                  if (to_state.TAG === /* Ok */0) {
                                    var order_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_type"), null));
                                    if (order_type.TAG === /* Ok */0) {
                                      var created_at = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "created_at"), null));
                                      if (created_at.TAG === /* Ok */0) {
                                        var delivery_instructions = Decco.optionFromJson(delivery_instructions_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "delivery_instructions"), null));
                                        if (delivery_instructions.TAG === /* Ok */0) {
                                          var delivery_note = Decco.optionFromJson(delivery_note_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "delivery_note"), null));
                                          if (delivery_note.TAG === /* Ok */0) {
                                            return {
                                                    TAG: /* Ok */0,
                                                    _0: {
                                                      customer: customer._0,
                                                      pickup_location: pickup_location._0,
                                                      drop_location: drop_location._0,
                                                      vehicle: vehicle._0,
                                                      has_waypoints: has_waypoints._0,
                                                      additional_waypoints_allowed: additional_waypoints_allowed._0,
                                                      additional_waypoints_eligible: additional_waypoints_eligible._0,
                                                      waypoints: waypoints._0,
                                                      geo_region_id: geo_region_id._0,
                                                      geo_region_name: geo_region_name._0,
                                                      distance: distance._0,
                                                      order_source: order_source._0,
                                                      payment_mode: payment_mode._0,
                                                      goods_type: goods_type._0,
                                                      goods_type_id: goods_type_id._0,
                                                      from_state: from_state._0,
                                                      to_state: to_state._0,
                                                      order_type: order_type._0,
                                                      created_at: created_at._0,
                                                      delivery_instructions: delivery_instructions._0,
                                                      delivery_note: delivery_note._0
                                                    }
                                                  };
                                          }
                                          var e = delivery_note._0;
                                          return {
                                                  TAG: /* Error */1,
                                                  _0: {
                                                    path: ".delivery_note" + e.path,
                                                    message: e.message,
                                                    value: e.value
                                                  }
                                                };
                                        }
                                        var e$1 = delivery_instructions._0;
                                        return {
                                                TAG: /* Error */1,
                                                _0: {
                                                  path: ".delivery_instructions" + e$1.path,
                                                  message: e$1.message,
                                                  value: e$1.value
                                                }
                                              };
                                      }
                                      var e$2 = created_at._0;
                                      return {
                                              TAG: /* Error */1,
                                              _0: {
                                                path: ".created_at" + e$2.path,
                                                message: e$2.message,
                                                value: e$2.value
                                              }
                                            };
                                    }
                                    var e$3 = order_type._0;
                                    return {
                                            TAG: /* Error */1,
                                            _0: {
                                              path: ".order_type" + e$3.path,
                                              message: e$3.message,
                                              value: e$3.value
                                            }
                                          };
                                  }
                                  var e$4 = to_state._0;
                                  return {
                                          TAG: /* Error */1,
                                          _0: {
                                            path: ".to_state" + e$4.path,
                                            message: e$4.message,
                                            value: e$4.value
                                          }
                                        };
                                }
                                var e$5 = from_state._0;
                                return {
                                        TAG: /* Error */1,
                                        _0: {
                                          path: ".from_state" + e$5.path,
                                          message: e$5.message,
                                          value: e$5.value
                                        }
                                      };
                              }
                              var e$6 = goods_type_id._0;
                              return {
                                      TAG: /* Error */1,
                                      _0: {
                                        path: ".goods_type_id" + e$6.path,
                                        message: e$6.message,
                                        value: e$6.value
                                      }
                                    };
                            }
                            var e$7 = goods_type._0;
                            return {
                                    TAG: /* Error */1,
                                    _0: {
                                      path: ".goods_type" + e$7.path,
                                      message: e$7.message,
                                      value: e$7.value
                                    }
                                  };
                          }
                          var e$8 = payment_mode._0;
                          return {
                                  TAG: /* Error */1,
                                  _0: {
                                    path: ".payment_mode" + e$8.path,
                                    message: e$8.message,
                                    value: e$8.value
                                  }
                                };
                        }
                        var e$9 = order_source._0;
                        return {
                                TAG: /* Error */1,
                                _0: {
                                  path: ".order_source" + e$9.path,
                                  message: e$9.message,
                                  value: e$9.value
                                }
                              };
                      }
                      var e$10 = distance._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: ".distance" + e$10.path,
                                message: e$10.message,
                                value: e$10.value
                              }
                            };
                    }
                    var e$11 = geo_region_name._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".geo_region_name" + e$11.path,
                              message: e$11.message,
                              value: e$11.value
                            }
                          };
                  }
                  var e$12 = geo_region_id._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".geo_region_id" + e$12.path,
                            message: e$12.message,
                            value: e$12.value
                          }
                        };
                }
                var e$13 = waypoints._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".waypoints" + e$13.path,
                          message: e$13.message,
                          value: e$13.value
                        }
                      };
              }
              var e$14 = additional_waypoints_eligible._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".additional_waypoints_eligible" + e$14.path,
                        message: e$14.message,
                        value: e$14.value
                      }
                    };
            }
            var e$15 = additional_waypoints_allowed._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".additional_waypoints_allowed" + e$15.path,
                      message: e$15.message,
                      value: e$15.value
                    }
                  };
          }
          var e$16 = has_waypoints._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".has_waypoints" + e$16.path,
                    message: e$16.message,
                    value: e$16.value
                  }
                };
        }
        var e$17 = vehicle._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".vehicle" + e$17.path,
                  message: e$17.message,
                  value: e$17.value
                }
              };
      }
      var e$18 = drop_location._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".drop_location" + e$18.path,
                message: e$18.message,
                value: e$18.value
              }
            };
    }
    var e$19 = pickup_location._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".pickup_location" + e$19.path,
              message: e$19.message,
              value: e$19.value
            }
          };
  }
  var e$20 = customer._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".customer" + e$20.path,
            message: e$20.message,
            value: e$20.value
          }
        };
}

function order_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var order_id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_id"), null));
  if (order_id.TAG === /* Ok */0) {
    var order_crn = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_crn"), null));
    if (order_crn.TAG === /* Ok */0) {
      var status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
      if (status.TAG === /* Ok */0) {
        var pickup_time = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "pickup_time"), null));
        if (pickup_time.TAG === /* Ok */0) {
          var order_updated_at = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_updated_at"), null));
          if (order_updated_at.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      order_id: order_id._0,
                      order_crn: order_crn._0,
                      status: status._0,
                      pickup_time: pickup_time._0,
                      order_updated_at: order_updated_at._0
                    }
                  };
          }
          var e = order_updated_at._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".order_updated_at" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = pickup_time._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".pickup_time" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = status._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".status" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = order_crn._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".order_crn" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = order_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".order_id" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function vas_services_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var is_helper_order = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_helper_order"), null));
  if (is_helper_order.TAG === /* Ok */0) {
    var is_helper_plus_labour_order = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_helper_plus_labour_order"), null));
    if (is_helper_plus_labour_order.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                is_helper_order: is_helper_order._0,
                is_helper_plus_labour_order: is_helper_plus_labour_order._0
              }
            };
    }
    var e = is_helper_plus_labour_order._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".is_helper_plus_labour_order" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = is_helper_order._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".is_helper_order" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function partner_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var vehicle_number = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_number"), null));
    if (vehicle_number.TAG === /* Ok */0) {
      var vehicle_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vehicle_type"), null));
      if (vehicle_type.TAG === /* Ok */0) {
        var mobile = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "mobile"), null));
        if (mobile.TAG === /* Ok */0) {
          var partner_secondary_mobile = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "partner_secondary_mobile"), null));
          if (partner_secondary_mobile.TAG === /* Ok */0) {
            var driver_msisdn = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "driver_msisdn"), null));
            if (driver_msisdn.TAG === /* Ok */0) {
              var has_nep = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "has_nep"), null));
              if (has_nep.TAG === /* Ok */0) {
                var fuel_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fuel_type"), null));
                if (fuel_type.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            name: name._0,
                            vehicle_number: vehicle_number._0,
                            vehicle_type: vehicle_type._0,
                            mobile: mobile._0,
                            partner_secondary_mobile: partner_secondary_mobile._0,
                            driver_msisdn: driver_msisdn._0,
                            has_nep: has_nep._0,
                            fuel_type: fuel_type._0
                          }
                        };
                }
                var e = fuel_type._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".fuel_type" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = has_nep._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".has_nep" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = driver_msisdn._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".driver_msisdn" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = partner_secondary_mobile._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".partner_secondary_mobile" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = mobile._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".mobile" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = vehicle_type._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".vehicle_type" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = vehicle_number._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".vehicle_number" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

function accepted_order_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var trip_accepted_time = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "trip_accepted_time"), null));
  if (trip_accepted_time.TAG === /* Ok */0) {
    var trip_accepted_location = Decco.optionFromJson(location_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "trip_accepted_location"), null));
    if (trip_accepted_location.TAG === /* Ok */0) {
      var driver_location_accuracy = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "driver_location_accuracy"), null));
      if (driver_location_accuracy.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  trip_accepted_time: trip_accepted_time._0,
                  trip_accepted_location: trip_accepted_location._0,
                  driver_location_accuracy: driver_location_accuracy._0
                }
              };
      }
      var e = driver_location_accuracy._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".driver_location_accuracy" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = trip_accepted_location._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".trip_accepted_location" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = trip_accepted_time._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".trip_accepted_time" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function live_order_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var trip_started_time = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trip_started_time"), null));
  if (trip_started_time.TAG === /* Ok */0) {
    var trip_started_location = Decco.optionFromJson(place_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "trip_started_location"), null));
    if (trip_started_location.TAG === /* Ok */0) {
      var trip_start_entry_timestamp = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "trip_start_entry_timestamp"), null));
      if (trip_start_entry_timestamp.TAG === /* Ok */0) {
        var trip_start_exit_timestamp = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "trip_start_exit_timestamp"), null));
        if (trip_start_exit_timestamp.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    trip_started_time: trip_started_time._0,
                    trip_started_location: trip_started_location._0,
                    trip_start_entry_timestamp: trip_start_entry_timestamp._0,
                    trip_start_exit_timestamp: trip_start_exit_timestamp._0
                  }
                };
        }
        var e = trip_start_exit_timestamp._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".trip_start_exit_timestamp" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = trip_start_entry_timestamp._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".trip_start_entry_timestamp" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = trip_started_location._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".trip_started_location" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = trip_started_time._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".trip_started_time" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function breach_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var breach_type = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "breach_type"), null));
  if (breach_type.TAG === /* Ok */0) {
    var drop_vicinity_passed = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "drop_vicinity_passed"), null));
    if (drop_vicinity_passed.TAG === /* Ok */0) {
      var waypoint_vicinity_passed = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "waypoint_vicinity_passed"), null));
      if (waypoint_vicinity_passed.TAG === /* Ok */0) {
        var fixed_fallback_fare_is_higher = Decco.optionFromJson(Decco.boolFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "fixed_fallback_fare_is_higher"), null));
        if (fixed_fallback_fare_is_higher.TAG === /* Ok */0) {
          var pickup_vicinity_passed = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "pickup_vicinity_passed"), null));
          if (pickup_vicinity_passed.TAG === /* Ok */0) {
            var waiting_time_passed = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "waiting_time_passed"), null));
            if (waiting_time_passed.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        breach_type: breach_type._0,
                        drop_vicinity_passed: drop_vicinity_passed._0,
                        waypoint_vicinity_passed: waypoint_vicinity_passed._0,
                        fixed_fallback_fare_is_higher: fixed_fallback_fare_is_higher._0,
                        pickup_vicinity_passed: pickup_vicinity_passed._0,
                        waiting_time_passed: waiting_time_passed._0
                      }
                    };
            }
            var e = waiting_time_passed._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".waiting_time_passed" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = pickup_vicinity_passed._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".pickup_vicinity_passed" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = fixed_fallback_fare_is_higher._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".fixed_fallback_fare_is_higher" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = waypoint_vicinity_passed._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".waypoint_vicinity_passed" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = drop_vicinity_passed._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".drop_vicinity_passed" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = breach_type._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".breach_type" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function ended_order_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var trip_ended_time = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trip_ended_time"), null));
  if (trip_ended_time.TAG === /* Ok */0) {
    var trip_ended_location = Decco.optionFromJson(place_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "trip_ended_location"), null));
    if (trip_ended_location.TAG === /* Ok */0) {
      var trip_end_exit_timestamp = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "trip_end_exit_timestamp"), null));
      if (trip_end_exit_timestamp.TAG === /* Ok */0) {
        var breach_info = Decco.optionFromJson(breach_info_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "breach_info"), null));
        if (breach_info.TAG === /* Ok */0) {
          var is_return_trip = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_return_trip"), null));
          if (is_return_trip.TAG === /* Ok */0) {
            var dry_run_distance = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "dry_run_distance"), null));
            if (dry_run_distance.TAG === /* Ok */0) {
              var dry_run_duration = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "dry_run_duration"), null));
              if (dry_run_duration.TAG === /* Ok */0) {
                var end_trip_fare_strategy = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "end_trip_fare_strategy"), null));
                if (end_trip_fare_strategy.TAG === /* Ok */0) {
                  var previous_due = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "previous_due"), null));
                  if (previous_due.TAG === /* Ok */0) {
                    var tax_on_commision = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "tax_on_commision"), null));
                    if (tax_on_commision.TAG === /* Ok */0) {
                      return {
                              TAG: /* Ok */0,
                              _0: {
                                trip_ended_time: trip_ended_time._0,
                                trip_ended_location: trip_ended_location._0,
                                trip_end_exit_timestamp: trip_end_exit_timestamp._0,
                                breach_info: breach_info._0,
                                is_return_trip: is_return_trip._0,
                                dry_run_distance: dry_run_distance._0,
                                dry_run_duration: dry_run_duration._0,
                                end_trip_fare_strategy: end_trip_fare_strategy._0,
                                previous_due: previous_due._0,
                                tax_on_commision: tax_on_commision._0
                              }
                            };
                    }
                    var e = tax_on_commision._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: ".tax_on_commision" + e.path,
                              message: e.message,
                              value: e.value
                            }
                          };
                  }
                  var e$1 = previous_due._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: ".previous_due" + e$1.path,
                            message: e$1.message,
                            value: e$1.value
                          }
                        };
                }
                var e$2 = end_trip_fare_strategy._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".end_trip_fare_strategy" + e$2.path,
                          message: e$2.message,
                          value: e$2.value
                        }
                      };
              }
              var e$3 = dry_run_duration._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".dry_run_duration" + e$3.path,
                        message: e$3.message,
                        value: e$3.value
                      }
                    };
            }
            var e$4 = dry_run_distance._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".dry_run_distance" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = is_return_trip._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".is_return_trip" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
        }
        var e$6 = breach_info._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".breach_info" + e$6.path,
                  message: e$6.message,
                  value: e$6.value
                }
              };
      }
      var e$7 = trip_end_exit_timestamp._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".trip_end_exit_timestamp" + e$7.path,
                message: e$7.message,
                value: e$7.value
              }
            };
    }
    var e$8 = trip_ended_location._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".trip_ended_location" + e$8.path,
              message: e$8.message,
              value: e$8.value
            }
          };
  }
  var e$9 = trip_ended_time._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".trip_ended_time" + e$9.path,
            message: e$9.message,
            value: e$9.value
          }
        };
}

function completed_order_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var trip_completed_time = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trip_completed_time"), null));
  if (trip_completed_time.TAG === /* Ok */0) {
    var customer_rating = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "customer_rating"), null));
    if (customer_rating.TAG === /* Ok */0) {
      var order_invoice_url = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_invoice_url"), null));
      if (order_invoice_url.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  trip_completed_time: trip_completed_time._0,
                  customer_rating: customer_rating._0,
                  order_invoice_url: order_invoice_url._0
                }
              };
      }
      var e = order_invoice_url._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".order_invoice_url" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = customer_rating._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".customer_rating" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = trip_completed_time._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".trip_completed_time" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function cancelled_order_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var cancellation_reason = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cancellation_reason"), null));
  if (cancellation_reason.TAG === /* Ok */0) {
    var trip_cancelled_time = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "trip_cancelled_time"), null));
    if (trip_cancelled_time.TAG === /* Ok */0) {
      var cancellation_source = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cancellation_source"), null));
      if (cancellation_source.TAG === /* Ok */0) {
        var is_penalty_applied = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_penalty_applied"), null));
        if (is_penalty_applied.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    cancellation_reason: cancellation_reason._0,
                    trip_cancelled_time: trip_cancelled_time._0,
                    cancellation_source: cancellation_source._0,
                    is_penalty_applied: is_penalty_applied._0
                  }
                };
        }
        var e = is_penalty_applied._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".is_penalty_applied" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = cancellation_source._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".cancellation_source" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = trip_cancelled_time._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".trip_cancelled_time" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = cancellation_reason._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".cancellation_reason" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function miscellaneous_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var is_outstation_order = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_outstation_order"), null));
  if (is_outstation_order.TAG === /* Ok */0) {
    var is_rental_order = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_rental_order"), null));
    if (is_rental_order.TAG === /* Ok */0) {
      var is_otp_order = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_otp_order"), null));
      if (is_otp_order.TAG === /* Ok */0) {
        var is_business_order = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "is_business_order"), null));
        if (is_business_order.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    is_outstation_order: is_outstation_order._0,
                    is_rental_order: is_rental_order._0,
                    is_otp_order: is_otp_order._0,
                    is_business_order: is_business_order._0
                  }
                };
        }
        var e = is_business_order._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".is_business_order" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = is_otp_order._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".is_otp_order" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = is_rental_order._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".is_rental_order" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = is_outstation_order._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".is_outstation_order" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function unallocated_order_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var create_trip_fare_strategy = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict._0, "create_trip_fare_strategy"), null));
  if (create_trip_fare_strategy.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              create_trip_fare_strategy: create_trip_fare_strategy._0
            }
          };
  }
  var e = create_trip_fare_strategy._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".create_trip_fare_strategy" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function status_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var unallocated_order_info = unallocated_order_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "unallocated_order_info"), null));
  if (unallocated_order_info.TAG === /* Ok */0) {
    var accepted_order_info = Decco.optionFromJson(accepted_order_info_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "accepted_order_info"), null));
    if (accepted_order_info.TAG === /* Ok */0) {
      var live_order_info = Decco.optionFromJson(live_order_info_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "live_order_info"), null));
      if (live_order_info.TAG === /* Ok */0) {
        var ended_order_info = Decco.optionFromJson(ended_order_info_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "ended_order_info"), null));
        if (ended_order_info.TAG === /* Ok */0) {
          var completed_order_info = Decco.optionFromJson(completed_order_info_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "completed_order_info"), null));
          if (completed_order_info.TAG === /* Ok */0) {
            var cancelled_order_info = Decco.optionFromJson(cancelled_order_info_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "cancelled_order_info"), null));
            if (cancelled_order_info.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        unallocated_order_info: unallocated_order_info._0,
                        accepted_order_info: accepted_order_info._0,
                        live_order_info: live_order_info._0,
                        ended_order_info: ended_order_info._0,
                        completed_order_info: completed_order_info._0,
                        cancelled_order_info: cancelled_order_info._0
                      }
                    };
            }
            var e = cancelled_order_info._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".cancelled_order_info" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = completed_order_info._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".completed_order_info" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = ended_order_info._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".ended_order_info" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = live_order_info._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".live_order_info" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = accepted_order_info._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".accepted_order_info" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = unallocated_order_info._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".unallocated_order_info" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var booking_info = booking_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "booking_info"), null));
  if (booking_info.TAG === /* Ok */0) {
    var order_info = order_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_info"), null));
    if (order_info.TAG === /* Ok */0) {
      var vas_services = vas_services_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "vas_services"), null));
      if (vas_services.TAG === /* Ok */0) {
        var partner_info = Decco.optionFromJson(partner_info_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "partner_info"), null));
        if (partner_info.TAG === /* Ok */0) {
          var status_info = status_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status_info"), null));
          if (status_info.TAG === /* Ok */0) {
            var miscellaneous_info = miscellaneous_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "miscellaneous_info"), null));
            if (miscellaneous_info.TAG === /* Ok */0) {
              var order_editability = Decco.optionFromJson(order_editability_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_editability"), null));
              if (order_editability.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          booking_info: booking_info._0,
                          order_info: order_info._0,
                          vas_services: vas_services._0,
                          partner_info: partner_info._0,
                          status_info: status_info._0,
                          miscellaneous_info: miscellaneous_info._0,
                          order_editability: order_editability._0
                        }
                      };
              }
              var e = order_editability._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".order_editability" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = miscellaneous_info._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".miscellaneous_info" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = status_info._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".status_info" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = partner_info._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".partner_info" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = vas_services._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".vas_services" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = order_info._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".order_info" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = booking_info._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".booking_info" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function order_details_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var order_details = t_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "order_details"), null));
  if (order_details.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              order_details: order_details._0
            }
          };
  }
  var e = order_details._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".order_details" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  landmark_decode ,
  location_decode ,
  contact_decode ,
  place_decode ,
  bookingInfoPlace_decode ,
  location_details_decode ,
  customer_info_decode ,
  vehicle_decode ,
  instructions_decode ,
  delivery_instructions_decode ,
  delivery_note_detail_decode ,
  delivery_note_decode ,
  order_editability_decode ,
  booking_info_decode ,
  order_info_decode ,
  vas_services_decode ,
  partner_info_decode ,
  accepted_order_info_decode ,
  live_order_info_decode ,
  breach_info_decode ,
  ended_order_info_decode ,
  completed_order_info_decode ,
  cancelled_order_info_decode ,
  miscellaneous_info_decode ,
  unallocated_order_info_decode ,
  status_info_decode ,
  t_decode ,
  order_details_decode ,
  
}
/* No side effect */
